/**
 * Copy Paste component.
 * On click, copies a source innerHTML to a target innerHTML.
 *
 */

const copypaste = function() {
	document.querySelectorAll('.js-copy-paste').forEach($trigger => {
		const $source =
			document.querySelector($trigger.getAttribute('data-copy-source')) || $trigger;
		const $target = document.querySelector($trigger.getAttribute('data-paste-target'));
		if (!$source || !$target) return;
		$trigger.addEventListener('click', () => {
			$target.innerHTML = $source.innerHTML;
		});
	});
};

module.exports = copypaste;
